import { IAddress } from '@smarttypes/core';
import { get, isObject } from 'lodash';

/**
 * Formats an address object into a comma-separated string.
 *
 * @param {IAddress} address - The address object to format.
 * @returns {string} A comma-separated string of address components, excluding the 'geo' property.
 * @example
 * // Returns "123 Main St, Anytown, CA, 12345, USA"
 * addressString({
 *   street: "123 Main St",
 *   city: "Anytown",
 *   state: "CA",
 *   zip: "12345",
 *   country: "USA",
 *   geo: { lat: 37.7749, lng: -122.4194 }
 * });
 */
export function addressString(address: IAddress): string {
  return !isObject(address)
    ? ''
    : Object.keys(address)
        .reduce((aggr: string[], item) => {
          if (item !== 'geo') {
            aggr.push(get(address, item) as string);
          }
          return aggr;
        }, [])
        .filter(f => !!f)
        .join(', ');
}
